import React from 'react';

import ProgressOverlay from './overlays/progress_overlay';

// Not sure the right way to do this with typescript, so theres errors in this file
export class BusyComponent<P, S = {}> extends React.PureComponent<P, S> {
  constructor(props, context) {
    super(props, context);
    this._isBusy = false;
    this.state = {
      is_busy: false,
    };
  }
  setBusy(): boolean {
    let ret = !this._isBusy;
    if (ret) {
      this._isBusy = true;
      this.setState({ is_busy: true });
    }
    return ret;
  }
  clearBusy(): void {
    this._isBusy = false;
    this.setState({ is_busy: false });
  }
}

type OverlayProps = {
  style?: any;
  isBusy: boolean;
};

export class BusyOverlay extends React.PureComponent<OverlayProps> {
  render(): React.ReactNode {
    const { style, isBusy } = this.props;
    let content = null;
    if (isBusy) {
      content = <ProgressOverlay style={style} />;
    }
    return content;
  }
}
export default BusyComponent;
